(() => {
  if (customElements.get('ge-announcement-rotator')) return;

  class GeAnnouncementRotator extends HTMLElement {
    constructor() {
      super();
      this._timer = null;
      this._items = [];
      this._index = 0;
      this._paused = false;
    }

    connectedCallback() {
      this.refresh();
      this.addEventListener('mouseenter', this.pause);
      this.addEventListener('mouseleave', this.resume);
    }

    disconnectedCallback() {
      this.clearTimer();
      this.removeEventListener('mouseenter', this.pause);
      this.removeEventListener('mouseleave', this.resume);
    }

    pause = () => {
      this._paused = true;
      this.clearTimer();
      // Paused mid-gap: never leave the bar empty.
      if (!this._items.some((el) => el.classList.contains('is-on'))) this._items[this._index]?.classList.add('is-on');
    };

    resume = () => {
      if (!this._autoplay || this._items.length < 2 || this._reduceMotion) return;
      this._paused = false;
      this.schedule();
    };

    refresh() {
      this.clearTimer();
      this._items = Array.from(this.querySelectorAll('.announcement-bar--item')).filter(
        (el) => (el.textContent || '').trim().length > 0
      );
      this._index = 0;
      this._paused = false;
      this._autoplay = this.dataset.autoplay !== 'false';
      this._interval = Math.max(3000, parseInt(this.dataset.autoplayMs, 10) || 5000);
      this._reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.classList.add('is-cycling');
      this._items.forEach((el, i) => el.classList.toggle('is-on', i === 0));

      if (this._items.length < 2 || !this._autoplay || this._reduceMotion) return;
      this.schedule();
    }

    schedule() {
      this.clearTimer();
      this._timer = window.setTimeout(() => this.advance(), this._interval);
    }

    advance() {
      if (this._paused || this._items.length < 2) return;
      // Sequential: the outgoing message fully fades out (FADE_MS) before the next fades in.
      const FADE_MS = 700;
      this._items[this._index]?.classList.remove('is-on');
      this._index = (this._index + 1) % this._items.length;
      const next = this._items[this._index];
      this._timer = window.setTimeout(() => {
        if (this._paused) return;
        next?.classList.add('is-on');
        this._timer = window.setTimeout(() => this.advance(), this._interval + FADE_MS);
      }, FADE_MS);
    }

    clearTimer() {
      if (this._timer) window.clearTimeout(this._timer);
      this._timer = null;
    }

    showItem(item) {
      this.clearTimer();
      this._paused = true;
      this._items.forEach((el) => el.classList.toggle('is-on', el === item));
    }

    resumeFromEditor() {
      this._paused = false;
      this.refresh();
    }
  }

  customElements.define('ge-announcement-rotator', GeAnnouncementRotator);

  window.geRefreshAnnouncementRotators = () => {
    document.querySelectorAll('ge-announcement-rotator').forEach((el) => el.refresh());
  };

  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest?.('.announcement-bar--item');
    const rotator = item?.closest('ge-announcement-rotator');
    if (rotator) rotator.showItem(item);
  });

  document.addEventListener('shopify:block:deselect', () => {
    document.querySelectorAll('ge-announcement-rotator').forEach((el) => el.resumeFromEditor());
  });
})();
